import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ReactPwa from "react-pwa-app";
import LoadingScreen from "./components/LoadingScreen";
import { ThemeProvider } from "@mui/material/styles";
import LightTheme from "./Themes/LightTheme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={LightTheme}>
      <ReactPwa
        test //is to install in localhost, not required
        suspense={
          <>
            <LoadingScreen />
          </>
        }
        config={{
          swUrl: "/install/service-worker.js", // sw file in public default is service-worker.js
          onUpdate: (reg) => {
           // alert("sw cache was updated");
            // console.log(reg);
          },
          onSuccess: (reg) => {
           // alert("sw success installed");
            // console.log(reg);
          },
          onError: (reg) => {
           // alert("sw error to install");
            // console.log(reg);
          },
          onPrompt: (e) => {
            if (e.outcome === "accepted") {
              //console.log("user click on install and accept");
            }
            if (e.outcome === "dismissed") {
              //console.log("user click on install and refuse");
            }
          },
        }}
      >
        <App />
      </ReactPwa>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
